import { Injectable } from '@angular/core';

@Injectable()
export class AssetService {
  PORTAL_ASSET_BASE_URL = 'https://passets.parrotanalytics.com/';
  constructor() { }

  getShowImageUrl(showId) {
    if (!showId) {
      return;
    }

    return this.PORTAL_ASSET_BASE_URL + 'tv/chart/' + showId.toString().replace(/-/gi, '') + '.jpg';
  }

  getShowBannerImageUrl(showId) {
    if (!showId) {
      return;
    }

    return this.PORTAL_ASSET_BASE_URL + 'tv/banner/' + showId.toString().replace(/-/gi, '') + '.jpg';
  }

  getShowPosterImageUrl(showId) {
    if (!showId) {
      return;
    }
    return this.PORTAL_ASSET_BASE_URL + 'tv/poster/' + showId.toString() + '.jpg';
  }

  getMarketImageUrl(marketiso) {
    if (!marketiso) {
      return;
    }

    return this.PORTAL_ASSET_BASE_URL + 'flags/' + marketiso.toLowerCase() + '.png';
  }

  getMarketMapUrl(marketiso) {
    if (!marketiso) {
      return;
    }

    return this.PORTAL_ASSET_BASE_URL + 'maps/' + marketiso.toLowerCase() + '_map.png';
  }

  getCustomersLogoUrl(accountId) {
    if (!accountId) {
      return '';
    }
    return this.PORTAL_ASSET_BASE_URL + 'client/' + accountId + '.png';
  }

  getPublisherLogoUrl(publisher) {
    if (!publisher) {
      return '';
    }
    return this.PORTAL_ASSET_BASE_URL + 'publishers/' + publisher.toLowerCase() + '.png';
  }

  getPlatformLogoUrl(id) {
    if (!id) {
      return;
    }
    return this.PORTAL_ASSET_BASE_URL + 'platforms/vod/' + id.toString() + '.png';
  }

  setDefaultChartPic( element ) {
    element.src = this.PORTAL_ASSET_BASE_URL + 'tv/chart/placeholder-chart-image.jpg';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/asset.service.ts